import React from "react";
import ForgotPassSection from "./../components/ForgotPassSection";

function ForgotpassPage(props) {
  return (
    <ForgotPassSection
      bg="white"
      textColor="dark"
      size="md"
      bgImage=""
      bgImageOpacity={1}
      title="Get a new password"
      subtitle=""
      buttonText="Reset password"
      inputSize="lg"
    ></ForgotPassSection>
  );
}

export default ForgotpassPage;
